import { getAllSpecializationAreasReq } from "../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../components/ui/InputField1"
import FileInput from "../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"

function RelationshipConsultor({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b33"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          errText="Please upload therapeutic qualifications"
          label="Therapeutic Qualifications (Degrees, Certifications) *"
          defaultValue={specialist?.profile?.specializationCertificate || []}
          placeholderText="Upload Therapeutic Qualifications (Degrees, Certifications)"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="counselingApproach"
          errText="Please enter counseling approach"
          defaultValue={specialist?.profile?.counselingApproach || ""}
          label="Counseling Approach (e.g., Cognitive Behavioral Therapy, Couples Therapy) *"
          placeholder="Enter Counseling Approach (e.g., Cognitive Behavioral Therapy, Couples Therapy)"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Areas of Specialization (e.g., Cognitive Behavioral Therapy, Couples Therapy) *"
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Upload Additional certificates"
          placeholderText="Upload Section for Licenses and Certifications"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Join our platform as a Relationship Counselor. Your skills in fostering understanding and resolving conflicts are vital. Please provide your professional information to begin helping individuals and couples enhance their relationships
      </Typography>
    </Fragment>
  )
}

export default RelationshipConsultor